import * as api from '../../api/retention';
import { asyncAction } from '../common';

export const changeFirstEvent = (event) => ({
  type: 'CHANGE_RETENTION_FIRST_EVENT',
  event,
});

export const changeReturnEvent = (event) => ({
  type: 'CHANGE_RETENTION_RETURN_EVENT',
  event,
});

export const changeDimensionType = (dimensionType) => ({
  type: 'CHANGE_RETENTION_DIMENSION_TYPE',
  dimensionType,
});

export const setRetentionExposureError = (error) => ({
  type: 'SET_RETENTION_EXPOSURE_ERROR',
  error,
});

export const changeRetentionView = (view) => ({
  type: 'CHANGE_RETENTION_VIEW',
  view,
});

export const toggleRetentionTrendLine = () => ({
  type: 'TOGGLE_RETENTION_TREND_LINE',
});

export const toggleRetentionAverageLine = () => ({
  type: 'TOGGLE_RETENTION_AVERAGE_LINE',
});

export const toggleRetentionMedianLine = () => ({
  type: 'TOGGLE_RETENTION_MEDIAN_LINE',
});

export const toggleRetentionAdaptive = () => ({
  type: 'TOGGLE_RETENTION_ADAPTIVE',
});

export const setRetentionExecuteId = (executeId) => ({
  type: 'SET_RETENTION_EXECUTE_ID',
  executeId,
});

export const executeRetention = (executeId) =>
  asyncAction('EXECUTE_RETENTION_QUERY', api.executeRetentionQuery(executeId));

export const exposeRetentionQuery = () =>
  asyncAction('EXPOSE_RETENTION_QUERY', api.exposeRetentionQuery());

export const executeRetentionCsv = () =>
  asyncAction('EXECUTE_RETENTION_QUERY_CSV', api.executeRetentionQueryCsv());
